// extracted by mini-css-extract-plugin
export default {"content_form":"FormLogin_content_form__HxiCT","content_formbutton":"FormLogin_content_formbutton__DgWov"};